import { useParams } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Stack, Container, useTheme, useMediaQuery } from "@mui/material";
import { Text } from "../components/Text";
import { Parentheses } from "../components/Parentheses";
import { TextKv } from "../components/TextKv";

import "../Wordpress.css";

type TNews = {
  id: number;
  title: string;
  content: string;
  date: string;
  category: number;
};

type TCategory = {
  id: number;
  name: string;
};

export const NewsDetail = () => {
  const { id } = useParams();
  const [news, setNews] = useState<TNews>();
  const [category, setCategory] = useState<TCategory[]>([]);
  const [categoryName, setCategoryName] = useState<string>("");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const categoryColor = (
    name: "Event" | "Information" | "Media" | "Press" | "Research" | string
  ) => {
    switch (name) {
      case "Event":
        return "#c88c23";
      case "Information":
        return "#438457";
      case "Media":
        return "#936aab";
      case "Press":
        return "#eac049";
      case "Research":
        return "#4a7695";
    }
    return "#ccc";
  };

  useEffect(() => {
    (async () => {
      const news = await axios.get(
        `${process.env.REACT_APP_API_URL}/news/${id}`
      );

      setNews({
        id: news.data.id,
        title: news.data.title?.rendered,
        content: news.data.content?.rendered,
        date: news.data.date,
        category: news.data.news_category[0],
      });

      const category = await axios.get(
        `${process.env.REACT_APP_API_URL}/news_category`
      );
      setCategory(
        category.data.map((c: any) => {
          return {
            id: c.id,
            name: c.name,
          };
        })
      );
    })();
  }, [id]);

  useEffect(() => {
    if (!news || !category) return;
    const name = category.find((c) => c.id === news.category)?.name;
    if (name) setCategoryName(name);
  }, [category, news]);

  return (
    <Stack minHeight="70vh">
      <TextKv text="NEWS" />
      <Container>
        {news && (
          <Parentheses>
            <Stack>
              <Text
                variant="h2"
                color="primary"
                fontSize={isMobile ? "24px !important" : 32}
                lineHeight={1.5}
              >
                {news?.title}
              </Text>
              <Stack
                direction="row"
                alignItems="center"
                marginTop={2.5}
                gap={2}
              >
                <Text color="#000">
                  {dayjs(news.date).format("YYYY.MM.DD")}
                </Text>
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  width={isMobile ? 100 : 150}
                  minWidth={isMobile ? 100 : 150}
                  height={isMobile ? 25 : 30}
                  sx={{
                    background: categoryColor(categoryName ? categoryName : ""),
                  }}
                >
                  <Text color="#fff" lineHeight={1}>
                    {categoryName ? categoryName : "未カテゴリ"}
                  </Text>
                </Stack>
              </Stack>
              <Stack
                marginTop={2}
                dangerouslySetInnerHTML={{ __html: news.content }}
              />
            </Stack>
          </Parentheses>
        )}
      </Container>
    </Stack>
  );
};
